import { $Q, $Qll } from '../utils/query-selector';
import { dataToggle, toggleDataActive } from '../utils/toggle-dataset';

/**
 * Reset re-render DOM
 * @param {HTMLElement} modal - node content video frame
 */
export function resetVideo(modal) {
  const wrapper = $Q('.video__modal-wrapper', modal);
  wrapper.innerHTML = $Q('.video__modal-youtube', modal).outerHTML;
}

/**
 * This function is responsible for creating the
 * video iframe once the section is visible in the viewport
 */
const createIframe = () => {
  const videoContainer = $Q('.video__modal-wrapper-js');
  if (!videoContainer) return;
  const videoBackground = $Q('.video__background-js');
  videoBackground.style.backgroundImage = `url(${videoBackground.dataset.src})`;
  const iframe = document.createElement("iframe");
  iframe.classList.add("video__modal-youtube", "youtube");
  iframe.setAttribute("src", videoContainer.dataset.src);
  iframe.setAttribute("allow", videoContainer.dataset.allow);
  iframe.setAttribute("allowfullscreen", "");
  iframe.setAttribute("title", videoContainer.dataset.title);
  videoContainer.appendChild(iframe);
}

/**
 * Init video section by id
 */
export const initVideoFrame = async () => {
  await createIframe();
  $Qll('.video__button').forEach((button) => {
    const { dataset: { section } } = button;

    toggleDataActive(
      `#play-button-${section}-js`,
      `#modal-video-${section}-js`,
      {
        overlay: true,
        closeSelector: ".video__close",
      }
    )
  })

  document.addEventListener("keydown", (event) => {
    if (event.code === "Escape") {

      const modal = $Q(".video__modal");
      if (modal.dataset.active === "true") {
        dataToggle(modal, true);
        resetVideo(modal);
      }
    }
  });
}
